import buildClickoutEvent from "../buildClickoutEvent";
import sendEvents from "../sendEvents";

export default function trackClickEvent(element: HTMLElement) {
  const Event = buildClickoutEvent(element);
  sendEvents(Event);
}
